import { useRef, useState } from "react";
import "./Resume.css";

function Resume() {
    const [coords, setCoords] = useState({ x: 50, y: 50 });
    const aboutRef = useRef<HTMLDivElement>(null);
    const sectionRefs = {
        about: useRef<HTMLDivElement>(null),
        projects: useRef<HTMLDivElement>(null),
        skills: useRef<HTMLDivElement>(null),
        contact: useRef<HTMLDivElement>(null),
    };
    const about = [
        
        { label: "👩‍💻 Software Engineer " },
        { label: "🎯 10+ years of experience delivering scalable solutions " },
        { label: "☁️ Expert in Cloud (Azure, AWS, GCP), AI & Data Engineering " },
        { label: "⚙️ Full-stack developer: Java, Python, JS/TS, Angular, React, Next.js" },
        { label: "💡 AI enthusiast: Prompt design, LLM apps, OpenAI integration " }
    ];
    const skills = [
        { icon: "./front.svg", label: "Frontend (React, Angular, Next.js)" },
        { icon: "./back.svg", label: "Backend (Java, Spring Boot, Node.js)" },
        { icon: "./cloud.svg", label: "Cloud (AWS, Azure, GCP)" },
        { icon: "./database.svg", label: "Databases (PostgreSQL, MongoDB, DynamoDB)" },
        { icon: "./ai.svg", label: "AI & LLMs (OpenAI, Prompt Engineering)" },
        { icon: "./chat.svg", label: "Prompt Design & Chatbots Power Automate" },
        { icon: "./devops.svg", label: "DevOps & Tools (Docker, Harness)" },
    ];
    const workList = [
        { id: 1, enterprise: "Accenture", time: "September 2021 - Current", role: "Custom Software Engineering Specialist"},
        { id: 2, enterprise: "Wiri Tecnologies", time: "September 2017 - June 2021", role: "Full Stack Developer"},
        { id: 3, enterprise: "Softek", time: "December 2016 - September 2017", role: "Frontend Developer"},
        { id: 4, enterprise: "Babel -&  Desteca", time: "April 2016 - December 2016", role: "Frontend and Backend Developer" },
        { id: 5, enterprise: "Dojogeek", time: "April 2015 - March 2016", role: "Custom Software Engineer Specialist"},
        { id: 6, enterprise: "Adesis Netlife", time: "February 2014 - March 2015", role: "Backend Developer"},
        { id: 7, enterprise: "Azka", time: "June 2013 - January 2014", role: "Backend Developer"},
        
    ];
    const contact = [
        {icon: "./github.svg", url: "https://github.com/igutierrezar"},
        { icon: "./linkedin.svg", url: "https://github.com/igutierrezar" },
        
    ];

  const scrollTo = (key: keyof typeof sectionRefs) => {
    sectionRefs[key].current?.scrollIntoView({ behavior: "smooth" });
  };

    const handleMouseMove = (e: any) => {
    const bounds = e.currentTarget.getBoundingClientRect();
    const x = ((e.clientX - bounds.left) / bounds.width) * 100;
    const y = ((e.clientY - bounds.top) / bounds.height) * 100;
    setCoords({ x, y });
    };

    return (
        <div className="resume-container">

            <div className="container">
                <h1 className="masked-text">I'm a Full Stack Developer
                </h1>
                <div className="mask-circle" />
            </div>
            <div>
                <button  onClick={() => scrollTo("about")}className="btn-down">
                    <img src="./arrow-down.svg" alt="" />
                </button>
            </div>

            {/* <div ref={sectionRefs.about} className="section"> */}
            <div ref={sectionRefs.about} className="about-section">
                <h1>I'm Irene a versatile Senior Software Engineer Specialized in Full-Stack Development, Cloud, and AI.</h1>
                <div className="about-info">
                    {about.map((about, idx) => (
                        <label>{ about.label} <br /></label>
                    ))}
                </div>
                
            </div>
            <div ref={sectionRefs.projects} className="work-section">
                <div className="work-label"><h1>Experience</h1></div>
                <div className="work">
                    {workList.map((work, idx) => (
                    <div key={idx} className="card">
                        {/* <div className="container"> */}
                            <h4><b>{work.role}</b></h4>
                                <strong>{ work.enterprise}</strong><br />
                                <small>{ work.time}</small>
                        {/* </div> */}
                    </div>
                ))}
                </div>

                
            </div>
            <div ref={sectionRefs.skills} className="skills-grid ">
                
                <div className="tech-areas">
                    <h1><img src="./code.svg" alt="Skills image" className="skill-img" /> Tech Areas </h1>
                </div>
                

                {/*  */}
                <div className="grid">
                    {skills.map((skill, idx) => (
                    <div key={idx} className="skill-card">
                        <img  src={skill.icon} className="skill-img-list" />
                        <div className="label">{skill.label}</div>
                    </div>
                    ))}
                </div>
                {/*  */}
            </div>
            <div ref={sectionRefs.skills}>
                <div>
                    <a href="https://github.com/igutierrezar" target="_blank"><img src="./github.svg"  className="contact-img" alt="" /></a>
                    <a href="https://www.linkedin.com/in/irenegutierrezar11/"  target="_blank"><img src="./linkedin.svg" className="contact-img" alt="" /></a>
                </div>
            </div>
            
        </div>
  );
}

export default Resume;
